import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BaseStepViewComponent } from 'app/main/components/dataset/components/common-step/base-step-view.class';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { IFormConfig, IDatasetConfig } from 'app/interfaces';
import { FormBuilder } from '@angular/forms';
import FilterFields from './form.fields';
import { ProductsConfig } from 'app/configs/datasets/products';
var TripResourceTripResourcesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TripResourceTripResourcesComponent, _super);
    function TripResourceTripResourcesComponent(datasetRS, datasetACS, datasetNavigatorService, formBuilder) {
        var _this = _super.call(this, datasetACS, datasetNavigatorService) || this;
        _this.datasetRS = datasetRS;
        _this.datasetACS = datasetACS;
        _this.datasetNavigatorService = datasetNavigatorService;
        _this.formBuilder = formBuilder;
        _this.dynamCols = [
            {
                name: 'code',
                title: 'Codice',
                primaryKey: true,
                show: true,
            },
            {
                name: 'description',
                title: 'Descrizione',
                primaryKey: false,
                show: true,
            }
        ];
        _this.displayedColumns = ['code', 'description', 'action'];
        _this.field = FilterFields.get('product_bundle_id');
        _this.filterFormGroup = _this.formBuilder.group({
            product_bundle_id: null,
        });
        return _this;
    }
    TripResourceTripResourcesComponent.prototype.ngOnInit = function () {
        this.formConfig = ProductsConfig.formConfigsMap['generalForm'];
    };
    return TripResourceTripResourcesComponent;
}(BaseStepViewComponent));
export { TripResourceTripResourcesComponent };
